import { isSourceAllowed, isSourceConnected, } from '#pplx/frontend/apps/ask/sources/hooks/sourceStatusPredicates.js';
import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
const FOLLOW_UP_DISABLED_UI_ACTION_IDS = new Set([
    'switch_to_search_mode',
    'toggle_incognito',
]);
/** Returns whether the action is available under the input and account restrictions. */
export function isComputerMenuActionAllowed({ action, isFollowUp, isAlwaysIncognitoRequired, }) {
    switch (action.type) {
        case 'connector':
            return isSourceAllowed(action.source) && isSourceConnected(action.source);
        case 'skill':
        case 'slash_command':
        case 'plugin':
            return true;
        case 'ui_action':
            if (action.actionId === 'toggle_incognito' && isAlwaysIncognitoRequired)
                return false;
            return !isFollowUp || !FOLLOW_UP_DISABLED_UI_ACTION_IDS.has(action.actionId);
        default:
            return assertUnreachableValue(action);
    }
}
export function dispatchComputerCommand({ action, icon, onSlashCommandSelect, onUiActionSelect, }) {
    switch (action.type) {
        case 'slash_command':
            onSlashCommandSelect(action, icon);
            return;
        case 'ui_action':
            onUiActionSelect(action);
            return;
        default:
            assertUnreachableValue(action);
    }
}
//# sourceMappingURL=computerCommandPolicy.js.map